// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import fa from 'vuetify/es5/locale/fa';
import router from './router';
import GlobalMethods from './globals';
import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import Truncate from 'lodash.truncate';
import VueAuth from '@websanova/vue-auth';
import VuetifyConfirm from 'vuetify-confirm';
Vue.config.productionTip = false;
Vue.use(VuetifyConfirm, {
  buttonTrueText: 'تایید',
  buttonFalseText: 'لغو',
  color: 'warning',
  icon: 'warning',
  title: 'هشدار',
  width: 350,
  property: '$confirm'
});
// Helpers
// Global filters
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(Vuetify, {
  rtl: true,
  lang: {
    locales: {
      fa,
    },
    current: 'fa'
  },
  // theme: {
  //   primary: colors.indigo.base, // #E53935
  //   secondary: colors.indigo.lighten4, // #FFCDD2
  //   accent: colors.indigo.base // #3F51B5
  // },
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary',
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: '',
    }
  },
  theme: {
    primary: '#1dc9b7'
  }
});
Vue.mixin(GlobalMethods);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});
Vue.router = router;

Vue.use(VueAuth, {
  auth: require('./auth/custom.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'type',
  registerData: {
    url: '/register/verify',
    method: 'POST',
    redirect: '/'
  },
  loginData: {
    url: 'reseller/login',
    method: 'POST',
    redirect: '/',
    fetchUser: true
  },
  logoutData: {
    url: 'auth/logout',
    method: 'POST',
    redirect: '/',
    makeRequest: false
  },
  oauth1Data: {
    url: 'login',
    method: 'POST'
  },
  fetchData: {
    url: 'reseller/who_am_i',
    method: 'GET',
    enabled: true
  },
  refreshData: {
    url: 'auth/refresh',
    method: 'GET',
    enabled: false,
    interval: 30
  },
  impersonateData: {
    url: 'auth/impersonate',
    method: 'POST',
    redirect: '/'
  },
  unimpersonateData: {
    url: 'auth/unimpersonate',
    method: 'POST',
    redirect: '/reseller',
    makeRequest: false
  },
  facebookData: {
    url: 'auth/facebook',
    method: 'POST',
    redirect: '/'
  },
  googleData: {
    url: 'auth/google',
    method: 'POST',
    redirect: '/'
  },
});

Vue.component('fake-item', {
  template: `<div class="white-widget grey-bg author-area">
      <div class="auth-info row">
        <div class="timeline-wrapper">
          <div class="timeline-item">
            <div class="animated-background">
              <div class="background-masker header-top"></div>
              <div class="background-masker header-left"></div>
              <div class="background-masker header-right"></div>
              <div class="background-masker header-bottom"></div>
              <div class="background-masker subheader-left"></div>
              <div class="background-masker subheader-right"></div>
              <div class="background-masker subheader-bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </div>`
});



// WEBPACK FOOTER //
// ./src/main.js